// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinksList_wrapper__n0oS6","link":"LinksList_link__MIcAE"};